import { createTheme } from '@mui/material/styles';
import { pxToRem } from './conversion';
function cssVar(name) {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(name)
        .trim();
}
// @ts-ignore
// @ts-ignore
var theme = createTheme({
    breakpoints: {
        values: {
            xs: 560,
            sm: 768,
            md: 1200,
            lg: 1366,
            xl: 1920,
        },
    },
    typography: {
        fontFamily: 'Lato',
        h1: {
            fontSize: pxToRem(32)
        },
        h3: {
            fontSize: pxToRem(26)
        },
        h5: {
            fontSize: pxToRem(20)
        }
    },
    palette: {
        progressBarLow: {
            main: '#FF7171',
        },
        progressBarMedium: {
            main: '#FFC171',
        },
        progressBarHigh: {
            main: '#8DCE68',
        },
        background: {
            default: 'ffffff',
        },
        success: {
            main: cssVar('--palette-success-main'),
            dark: cssVar('--palette-success-dark'),
            light: cssVar('--palette-success-light'),
            contrastText: '#fff',
        },
        primary: {
            main: cssVar('--palette-primary-main'),
            dark: cssVar('--palette-primary-dark'),
            light: cssVar('--palette-primary-light'),
        },
        secondary: {
            main: cssVar('--palette-secondary-main'),
            dark: cssVar('--palette-secondary-dark'),
            light: cssVar('--palette-secondary-light'),
            contrastText: '#fff',
        },
        info: {
            main: cssVar('--palette-info-main'),
            dark: cssVar('--palette-info-dark'),
            light: cssVar('--palette-info-light'),
        },
        warning: {
            main: cssVar('--palette-warning-main'),
            dark: cssVar('--palette-warning-dark'),
            light: cssVar('--palette-warning-light'),
        },
        error: {
            main: cssVar('--palette-error-main'),
            dark: cssVar('--palette-error-dark'),
            light: cssVar('--palette-error-light'),
        },
    },
    components: {
        MuiSnackbar: {
            styleOverrides: {}
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    boxShadow: "0px 3px 6px #00000029",
                    borderRadius: "4px",
                    color: "white",
                    '& .MuiAlert-icon': { color: 'white' }
                },
                standardError: {
                    background: "var(--palette-error-dark) 0% 0% no-repeat padding-box",
                    color: "white",
                },
                standardInfo: {
                    background: "var(--palette-info-dark) 0% 0% no-repeat padding-box",
                    color: "white"
                },
                standardSuccess: {
                    background: "var(--palette-success-dark) 0% 0% no-repeat padding-box",
                    color: "white"
                },
                standardWarning: {
                    background: "var(--palette-warning-dark) 0% 0% no-repeat padding-box",
                    color: "white"
                },
                icon: {
                    color: "white"
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontSize: pxToRem(16),
                    fontWeight: 'bold',
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontWeight: '500',
                    // color: 'var(--palette-secondary-dark)'
                }
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontWeight: 'bold',
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: pxToRem(16),
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    border: 'none',
                    boxShadow: 'none',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
                outlined: {
                    borderColor: 'Var(--palette-primary-main)',
                },
                containedPrimary: {},
            },
        },
        MuiButtonGroup: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    flexWrap: 'wrap',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    backgroundColor: 'transparent',
                },
                paperWidthMd: {
                    maxWidth: '768px',
                    width: '768px',
                    maxHeight: '480px',
                    height: '480px',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    color: 'var(--palette-secondary-dark)',
                    font: 'var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-24)/var(--unnamed-line-spacing-24) var(--unnamed-font-family-lato)',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    paddingRight: '30px',
                    paddingBottom: '30px',
                    paddingTop: '30px'
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorTransparent: {
                    color: 'var(--unnamed-color-ffffff)',
                    '& > *': {
                        color: 'var(--unnamed-color-ffffff)',
                    },
                },
                colorInherit: {
                    color: cssVar('--unnamed-color-fffff'),
                },
                colorPrimary: {
                    color: cssVar('--unnamed-color-fffff'),
                },
                positionFixed: {
                    backgroundColor: cssVar('--palette-black-1'),
                    color: cssVar('--unnamed-color-fffff'),
                },
                positionSticky: {
                    backgroundColor: cssVar('--palette-black-1'),
                    color: cssVar('--unnamed-color-fffff'),
                    '& > *': {
                        color: 'var(--unnamed-color-ffffff)',
                    },
                },
                positionStatic: {
                    backgroundColor: cssVar('--palette-black-1'),
                    color: cssVar('--unnamed-color-fffff'),
                },
                root: {
                    color: 'var(--unnamed-color-ffffff)',
                    '& > *': {
                        color: 'var(--unnamed-color-ffffff)',
                    },
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    color: 'var(--unnamed-color-ffffff)',
                    '& > *': {
                        color: 'var(--unnamed-color-ffffff)',
                    },
                    minHeight: '14px',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontSize: '15px'
                },
                icon: {
                    marginLeft: '10px',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: '#FDFDFD1A',
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    borderColor: 'var(--unnamed-color-ffffff)',
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                gutters: {
                    borderColor: 'var(--unnamed-color-ffffff)',
                },
                root: {
                    backgroundColor: 'transparent',
                    color: 'var(--unnamed-color-ffffff)',
                    borderRadius: '0',
                    boxShadow: 'none',
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    color: 'var(--palette-black-1)',
                },
                primary: {
                // font: 'var(--unnamed-font-style-normal) normal var(--unna med-font-weight-bold) var(--unnamed-font-size-24)/48px var(--unnamed-font-family-lato)',
                // color: 'var(--palette-secondary-dark)'
                },
                secondary: {
                    // font: 'var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-16)/48px var(--unnamed-font-family-lato)',
                    color: '--palette-secondary-500',
                    fontSize: '16px'
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: '30px',
                },
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                    border: '1px solid #E0E0E0',
                    opacity: 1,
                    color: 'black',
                },
            },
        },
        MuiListItemAvatar: {
            styleOverrides: {
                root: {
                    minWidth: '45px',
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: 'var(--unnamed-color-ffffff)',
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    letterSpacing: 'var(--unnamed-character-spacing-0-8)',
                    color: 'var(--palette-black-1)',
                    textAlign: 'left',
                    font: 'normal normal normal 16px/19px Lato',
                    opacity: 1,
                    borderColor: 'var(--unnamed-color-ffffff)',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                container: {
                    listStyle: "none",
                    listStyleType: "none"
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    background: 'var(--palette-offwhite-3) 0% 0% no-repeat padding-box',
                    '&:nth-of-type(odd)': {
                        background: 'var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box',
                    },
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    background: 'transparent 0% 0% no-repeat padding-box',
                    borderRadius: '6px',
                    boxShadow: 'none',
                    border: '1px solid #E6E6E6',
                },
            },
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    background: '#F5F5F5 0% 0% no-repeat padding-box',
                    boxShadow: '0px 3px 6px #00000029',
                },
            },
        },
        MuiTableFooter: {
            styleOverrides: {
                root: {
                    border: 'none !important',
                    boxShadow: 'none',
                },
            },
        },
        // @ts-ignore
        MUIDataTableFooter: {
            styleOverrides: {
                root: {
                    border: 'none !important',
                    boxShadow: 'none',
                },
            },
        },
        // @ts-ignore
        MUIDataTableHeadCell: {
            styleOverrides: {
                root: {
                    background: 'var(--palette-offwhite-3) 0% 0% no-repeat padding-box',
                    justifyContent: 'center',
                },
                contentWrapper: {
                    justifyContent: 'center',
                },
                data: {
                    background: 'var(--palette-offwhite-3) 0% 0% no-repeat padding-box',
                    font: 'var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-15)/var(--unnamed-line-spacing-24) var(--unnamed-font-family-lato)',
                    letterSpacing: 'var(--unnamed-character-spacing-0-3)',
                    color: 'var(--palette-black-1)',
                },
            },
        },
        MuiTableSortLabel: {},
        // @ts-ignore
        MUIDataTableSelectCell: {
            styleOverrides: {
                headerCell: {
                    background: 'var(--palette-offwhite-3) 0% 0% no-repeat padding-box',
                    color: 'black',
                },
            },
        },
        MUIDataTableToolbar: {
            styleOverrides: {
                root: {
                    paddingLeft: 0,
                },
                left: {
                    textAlign: 'left',
                },
                titleRoot: {
                    font: 'var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-24)/var(--unnamed-line-spacing-24) var(--unnamed-font-family-lato)',
                    letterSpacing: 'var(--unnamed-character-spacing-0-48)',
                    color: 'var(--palette-secondary-dark)',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    color: 'var(--palette-black-1)',
                    textAlign: 'center',
                    font: 'normal normal bold 15px/24px Lato',
                    letterSpacing: '0.3px',
                    height: '50px'
                },
                root: {
                    background: 'transparent 0% 0% no-repeat padding-box',
                    padding: '8px',
                    textAlign: 'center',
                    border: 'none',
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                scroller: {
                    borderBottom: "solid 1px var(--palette-offwhite-4)"
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    border: "none",
                    outline: "none",
                    "&:active": {
                        outline: "none",
                        border: "none"
                    },
                    "&:focus": {
                        outline: "none",
                        border: "none"
                    },
                    "&:hover": {
                        outline: "none",
                        border: "none"
                    }
                },
                //@ts-ignore
                "&:active": {
                    outline: "none",
                },
                //@ts-ignore
                "&:hover": {
                    outline: "none",
                },
                //@ts-ignore
                "&:focus": {
                    outline: "none",
                },
                // @ts-ignore
                '&.Mui-selected': {
                    border: "6px solid yellow",
                    outline: "none"
                },
                "& .Mui-selected": {
                    border: "6px solid red",
                    outline: "none"
                }
            }
        },
        MuiListItemSecondaryAction: {
            styleOverrides: {
                root: {
                    right: '0',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    textDecoration: 'none'
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    padding: '30px',
                    boxShadow: " 0px 4px 5px #0000001A",
                    borderRadius: "10px",
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    color: "var(--palette-black-1)"
                },
                selectLabel: {
                    color: "var(--palette-black-1)",
                    marginTop: "12px"
                },
                displayedRows: {
                    color: "var(--palette-black-1)",
                    marginTop: "12px"
                },
                select: {
                    color: "var(--palette-black-1)",
                    border: "1px solid var(--palette-black-1)"
                },
                actions: {
                    color: "var(--palette-black-1)",
                }
            },
        }
    },
    // @ts-ignore
    overrides: {
        MUIRichTextEditor: {
            root: {},
            container: {},
            editorContainer: {
            // marginTop:0,
            // paddingTop:0,
            // height: "200px",
            // maxHeight: "400px",
            },
            editor: {
                height: '200px',
                maxHeight: '400px',
                overflow: 'auto',
                border: '1px solid var(--palette-secondary-light)',
            },
            toolbar: {},
            placeHolder: {},
            anchorLink: {},
        },
    },
});
export default theme;
